import { IAppState } from '../../../AppModulesWrapper';
import { EUnavailableReason } from '../../types/reducers/publishTerms';

export const selectIsPromotionForbidden = (state: IAppState): boolean => {
  const services = Object.values(state.servicePickerWidget.publishTerms.services);

  return (
    Boolean(services.length) &&
    services.every(({ unavailableReasonType: r }) => r === EUnavailableReason.deniedBySanctions)
  );
};
